import type { IconName } from '@fortawesome/fontawesome-svg-core';
import type { DetailListProPracticalItemType } from './types';

export const ICON_NAME: Record<DetailListProPracticalItemType, IconName> = {
  employeeNumbers: 'male',
  paymentMethods: 'credit-card',
  shop: 'shopping-cart',
  shopGroomer: 'shopping-cart',
  parking: 'parking',
  onlineAppointment: 'calendar-check',
  selfDogWash: 'water',
  graduated: 'graduation-cap',
  formations: 'graduation-cap',
  acceptsNewClients: 'user',
  acceptedAnimals: 'paw',
  visitAtHome: 'home',
  practicePlaces: 'search-location',
};
